import { Component, InjectionToken, Input, OnInit } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { CallcardService } from '@services/callcard/callcard.service';
import { Events } from '@services/events/events.service';
import { NavService } from '@services/navigation/navigation.service';
import { ViewConfigurationService } from '@services/view-configuration/view-configuration.service';
import { ADDIN_VIEW_EVENT_KEY } from '@techwan/ionic-core';
import { CardPageService } from '../../services/card-page/card-page.service';

export const CALLCARD_VIEW_TOKEN = new InjectionToken('CALLCARD_VIEW_TOKEN');

/**
 * @description
 * A detail view  of a callcard
 */
@Component({
  template: ''
})
export class CallcardDetailBaseComponent implements OnInit {
  @Input()
  callcard: CallCard = null;

  get page() {
    return this.callcard !== null ? this._pages.getPage(this.callcard) : 0;
  }
  set page(page: number) {
    if (this.callcard !== null) {
      this._pages.setPage(this.callcard, page);
    }
  }

  constructor(
    protected callcardService: CallcardService,
    private events: Events,
    private navService: NavService,
    private view: ViewConfigurationService,
    protected _pages: CardPageService
  ) {}

  ngOnInit() {
    if (this.callcard !== null) {
      this.callcard.hasCacheChanged = false;
    }
  }

  openMap() {
    this.navService.getViewOpen(this.view.getMapName()).then(mapView => {
      // Won't be used since the button is hidden in tablet mode !
      if (mapView) {
        mapView.centerOnCard(this.callcard, 1);
      } else {
        this.events.publish(ADDIN_VIEW_EVENT_KEY, this.view.getMapName(), {
          location: this.callcard.location
        });
      }
    });
  }
}
